import Lock from '../../src/legacy/Lock.tsx';
export default Lock;
